/**
 * Tiny className combiner. Filters out falsy values and joins the rest with
 * spaces, so callers can pass conditional classes without pulling in a
 * dependency like `clsx`.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
